import React, { useCallback, useState } from 'react';
import plusIcon from '../../assets/plus-icon.svg';
import lessIcon from '../../assets/less-icon.svg';
import './Accordion.css';

const AccordionItem = ({
  id,
  title,
  expanded = false,
  children,
  onExpand = () => { },
}) => {
  const descriptionId = `${id}-description`;

  const onClick = useCallback(() => {
    onExpand(id);
  }, [id, onExpand]);

  return (
    <div className="Accordion-item">
      <h2>
        <button
          aria-controls={descriptionId}
          aria-expanded={expanded}
          className="Accordion-item-toggle Like-span"
          id={id}
          onClick={onClick}
          type="button"
        >
          <span>{title}</span>

          <img alt="" src={expanded ? lessIcon : plusIcon} />
        </button>
      </h2>

      <div aria-labelledby={id} id={descriptionId}>
        {expanded ? children : null}
      </div>
    </div>
  );
};

const Accordion = ({
  items = [],
  ContentComponent = () => null,
  uniqueExpaned = false,
}) => {
  const [expanded, setExpanded] = useState([]);

  const onToggleItem = useCallback((itemId) => {
    setExpanded((prevExpanded) => {
      if (prevExpanded.includes(itemId)) {
        return prevExpanded.filter((id) => id !== itemId);
      }
      const newArr = uniqueExpaned ? [] : [...prevExpanded];
      return [...newArr, itemId];
    });
  }, [uniqueExpaned]);

  return (
    <div className="Accordion">
      {items.map((item) => (
        <AccordionItem
          key={item.id}
          expanded={expanded.includes(item.id)}
          id={item.id}
          onExpand={onToggleItem}
          title={item.title}
        >
          <ContentComponent content={item.content} />
        </AccordionItem>
      ))}
    </div>
  );
};

export { Accordion };
